var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReportFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66669 13.7487C3.66669 13.7487 4.58335 12.832 7.33335 12.832C10.0834 12.832 11.9167 14.6654 14.6667 14.6654C17.4167 14.6654 18.3334 13.7487 18.3334 13.7487V2.7487C18.3334 2.7487 17.4167 3.66536 14.6667 3.66536C11.9167 3.66536 10.0834 1.83203 7.33335 1.83203C4.58335 1.83203 3.66669 2.7487 3.66669 2.7487V13.7487ZM3.66669 13.7487V20.1654",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportFlag);
export default __webpack_public_path__ + "static/media/icon-report-flag.6b24b593847e338c8b86fac634c20f87.svg";
export { ForwardRef as ReactComponent };